<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">PORTAL系统</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>Banner设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <el-tabs v-model="defaultTab" type="card" @tab-click="handleTabClick">
        <el-tab-pane
            key="banner"
            label="Banner设置"
            name="banner"
        >
          <div class="page-actions">
            <el-select :value="query.language" @change="handleQueryChange('language', $event)" placeholder="请选择">
              <el-option
                  v-for="item in languageList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-select :value="query.platform" @change="handleQueryChange('platform', $event)" placeholder="请选择">
              <el-option
                  v-for="item in platformTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-select :value="query.type" @change="handleQueryChange('type', $event)" placeholder="请选择">
              <el-option
                  v-for="item in bannerTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <create-banner @refresh="refreshList"></create-banner>
          </div>
          <banner-list @refresh="refreshList"></banner-list>
        </el-tab-pane>

        <el-tab-pane
            key="notice"
            label="公告设置"
            name="notice"
        >
          <div class="page-actions">
            <create-notice @refresh="refreshNoticeList"></create-notice>
          </div>
          <notice-list @refresh="refreshNoticeList"></notice-list>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import './store';
import BannerList from './components/list';
import NoticeList from './components/list/noticeIndex';
import CreateBanner from './components/create';
import {mapActions, mapState, mapMutations} from 'vuex';
import CreateCurrencyIntroduction from "@/entries/Setting/CurrencyIntroduction/components/create/index.vue";
import CreateNotice from "./components/create/noticeIndex.vue";

export default {
  name: 'BannerNewSetting',
  data() {
    return {
      defaultTab: 'banner'
    };
  },
  components: {
    CreateNotice,
    CreateCurrencyIntroduction,
    BannerList,
    NoticeList,
    CreateBanner
  },
  computed: {
    ...mapState('BannerNewSetting', ['platformTypeList', 'languageList', 'query', 'bannerTypeList', 'pagination'])
  },
  methods: {
    ...mapActions('BannerNewSetting', ['list', 'listNotice']),
    ...mapMutations('BannerNewSetting', ['changeQuery']),
    refreshList() {
      this.list(this.query);
    },
    handleTabClick(tab) {
      if (tab.name === 'notice') {
        this.refreshNoticeList();
      }
    },
    refreshNoticeList() {
      this.listNotice({
        page: this.pagination.page,
        size: this.pagination.size
      });
    },
    handleQueryChange(type, value) {
      this.changeQuery({
        ...this.query,
        [type]: value
      });
      this.refreshList();
    }
  },
  created() {
    this.list(this.query);
  }
};
</script>

<style lang="less" scoped>
</style>
